// This JSDoc module comment is put only in one of the files in this folder
// it is for documentation grouping purpose
/**
 * @module helpers/urlHelper
 */

/**
 * Get Api url from global variable
 * @memberof module:helpers/urlHelper
 * @function
 * @example
 * getApiUrl(window)
 * // => 'http://api.local.host:8089'
 */

function getApiUrl(globalVar) {
  return (
    // essos page
    (globalVar && globalVar.APP && globalVar.APP.apiURL) ||
    // mothership page
    (globalVar &&
      globalVar.blGlobal &&
      globalVar.blGlobal.application &&
      globalVar.blGlobal.application.api_url) ||
    // default
    'https://api.bukalapak.com'
  );
}

export default getApiUrl;
